import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { BrandTitle } from '../styles';
import Dropzone from './dropzone';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 30px;
  min-height: 200px;
`;

const Wrapper = styled.div`
  width: 245px;
  height: 114px;
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d7dfe7;
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(50, 50, 71, 0.06), 0px 1px 4px rgba(50, 50, 71, 0.06);

  > img {
    max-height: 114px;
    max-width: 245px;
  }
`;

const Err = styled.p`
  color: ${props => props.theme.errorColor};
  font: ${props => props.theme.fontWeightBold} 12px/120% ${props => props.theme.fontFamilyBody};
  margin: 10px -25px 0px -25px;
`;

const Button = styled.button`
  border: none;
  text-transform: uppercase;
  background: none;
  font: ${props => props.theme.fontWeightHeavy} 12px/120% ${props => props.theme.fontFamilyBody};
  align-self: flex-end;
  color: ${props => props.theme.secondaryColor};
`;

export default function Upload({ logo, onChange }) {
  const [preview, setPreview] = React.useState(null);
  const [error, setError] = React.useState(null);

  const mLogo = React.useMemo(() => logo, [logo]);

  React.useEffect(() => {
    setPreview(mLogo);
  }, [mLogo]);

  useChangeAwareEffect(({ did }) => {
    did.preview.change && (preview !== mLogo) && onChange(preview);
  }, { preview, mLogo, onChange });

  return (
    <Container>
      <BrandTitle>Upload Logo</BrandTitle>
      {
        preview
          ? <Wrapper><img src={preview.content || preview} alt="logo" /></Wrapper>
          : <Dropzone onError={setError} onSuccess={setPreview} />
      }
      {!!error && <Err>{error}</Err>}
      {!!preview && <Button type="button" onClick={() => setPreview(null)}>remove</Button>}
    </Container>
  );
}

Upload.propTypes = {
  logo: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

Upload.defaultProps = { logo: null };
